// react
import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

// ---
import { Search } from '@mui/icons-material';

const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate();

  const onHandleSubmit = (e) => {
    e.preventDefault();

    if (searchTerm) {
      navigate(`/search/${searchTerm}`);

      setSearchTerm('');
    }
  };

  return (
    <form onSubmit={onHandleSubmit} className='w-full flex items-center space-x-2 pl-1 bg-gray-900 rounded'>
      <button type='submit' className='py-2 px-3 text-red-600'>
        <Search />
      </button>
      <input value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className='w-full bg-transparent outline-none' placeholder='Search...' />
    </form>
  );
};

export default SearchBar;
